<template>
    <div>
        <header-component/>
        <sidebar-component/>
        <div id="wrapper">
            <slot />
            <footer-component/>
        </div>
        <div class="custom-modal-backdrop"></div>
    </div>
</template>

<script>

    import HeaderComponent from '../layout/Header.vue'
    import SidebarComponent from '../layout/Sidebar.vue'
    import FooterComponent from '../layout/Footer.vue'

    export default {
        components: {
            HeaderComponent,
            SidebarComponent,
            FooterComponent
        },
        methods: {},
        mounted: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layouts/UserLayout.vue